module.exports = __webpack_public_path__ + "img/id-card2.75e994b5.svg";